var fonts = {
  bold: "'ThomasHeadlineBold', 'Arial Black'",
  "default": "'Source Sans Pro', 'Arial'",
  regular: "'ThomasHeadlineRegular', 'Arial'",
  wave: "'NLTGWaveSerif', 'Arial'"
};

export { fonts };
//# sourceMappingURL=fonts.js.map
